import createUrl, { DOMAIN } from '../urlCreator/urlCreator';

/**
 * so-net共通フッター
 */
const SncInformation = () => {
    return (
        <div className="gFt2017_footer">
            <ul className="gFt2017_corporationLink">
                <li>
                    <a href={createUrl(DOMAIN.SONY_NETWORK, '/corporation/')}>会社情報</a>
                </li>
                <li>
                    <a href={createUrl(DOMAIN.SONY_NETWORK, '/corporation/safety/')}>個人情報保護/情報セキュリティ</a>
                </li>
                <li>
                    <a href={createUrl(DOMAIN.SONET, '/siteinfo/so-net/')}>ご利用について</a>
                </li>
            </ul>
            <div className="gFt2017_policy">
                <p>
                    <a href="http://privacymark.jp/" target="_blank" rel="noopener noreferrer">
                        <img
                            src={createUrl(DOMAIN.SONET, '/common/hf1704/img/pmark.png')}
                            alt="たいせつにしますﾌﾟﾗｲﾊﾞｼｰ 10470001"
                        />
                    </a>
                </p>
                <p>
                    <a href={createUrl(DOMAIN.SONY_NETWORK, '/corporation/isms/')}>
                        <img
                            src={createUrl(DOMAIN.SONET, '/common/hf1704/img/isms.png')}
                            alt="is 571190 / ISO 27001:2013"
                        />
                    </a>
                </p>
            </div>
            <p className="gFt2017_copyright">
                <small>© Sony Network Communications Inc.</small>
            </p>
        </div>
    );
};

export default SncInformation;
